import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Button } from '@/components/UI/Button/Button';

export const InfoDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const InfoDrawerLogo = styled(IconBox).attrs({
  $filename: 'Tap.svg',
  $width: 60,
  $height: 18,
  $iconWidth: 60,
  $iconHeight: 18,
})`
  margin-bottom: 20px;
  width: 80px;
`;

export const InfoDrawerTitle = styled(Typography.Header).attrs({
  $variant: '2',
})<{ $isError: boolean }>`
  ${({ $isError }) =>
    $isError &&
    css`
      color: ${({ theme }) => theme.palette.system.red};
    `}
`;

export const InfoDrawerMessage = styled(Typography.Body).attrs({
  $variant: '1',
})`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const InfoDrawerButton = styled(Button).attrs({
  appearance: 'secondaryLight',
  isFullWidth: true,
})``;

export const InfoDrawerLink = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.blue};
  text-decoration-line: underline;
  text-underline-position: under;
`;
